import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";

import { withTranslation, Link } from "../../../i18n";

import "./Panel.scss";

const ServicePanel = ({ t }) => {
    const [moreServices, setMoreServices] = useState(false);
    const router = useRouter();

    useEffect(() => {
        if (router.pathname === "/uslugi") {
            setMoreServices(true);
            if (window.location.hash !== "") {
                linksManipulations(false);
            } else {
                linksManipulations(true);
            }
        } else {
            linksManipulations(true);
        }
    }, [router]);

    const linksManipulations = onlyDelete => {
        let links = [
            ...document.querySelectorAll(
                ".more_info_panel .more_panel.services_menu_item button + .more_services_panel a"
            )
        ];

        if (onlyDelete) {
            links.forEach(el => {
                if (el.classList.contains("active")) {
                    el.classList.remove("active");
                }
            });
        } else {
            links.forEach(el => {
                if (el.href.includes(window.location.hash)) {
                    setMoreServices(true);
                    el.classList.add("active");
                } else {
                    if (el.classList.contains("active")) {
                        el.classList.remove("active");
                    }
                }
            });
        }
    };

    return (
        <div className="panel_wrapper">
            <div className="more_info_panel">
                <div className={router.pathname === "/o-nas" ? "more_panel active" : "more_panel"}>
                    <Link href={`/o-nas`} prefetch={false}>
                        <a>{t("О нас")}</a>
                    </Link>
                </div>
                <div className={router.pathname === "/oplata-i-dostavka" ? "more_panel active" : "more_panel"}>
                    <Link href={`/oplata-i-dostavka`} prefetch={false}>
                        <a>{t("Оплата и доставка")}</a>
                    </Link>
                </div>
                <div className={router.pathname === "/usloviya-vozvrata-tovara" ? "more_panel active" : "more_panel"}>
                    <Link href={`/usloviya-vozvrata-tovara`} prefetch={false}>
                        <a>{t("Условия возврата товара")}</a>
                    </Link>
                </div>
                <div className={router.pathname === "/kontakty" ? "more_panel active" : "more_panel"}>
                    <Link href={`/kontakty`} prefetch={false}>
                        <a>{t("Контакты")}</a>
                    </Link>
                </div>
                <div
                    className={`services_menu_item more_panel${router.pathname === "/uslugi" ? " active" : ""}${
                        moreServices ? " open" : ""
                    }`}
                >
                    <Link href={`/uslugi`} prefetch={false}>
                        <a>{t("Услуги")}</a>
                    </Link>
                    <button className="more_services" onClick={() => setMoreServices(!moreServices)}>
                        <div>
                            <span></span>
                            <span></span>
                        </div>
                    </button>
                    <div className={`more_services_panel${moreServices ? " open" : ""}`}>
                        <Link href={`/uslugi#remont`}>
                            <a>
                                <span>{t("Ремонтно-строительные работы")}</span>
                            </a>
                        </Link>
                        <Link href={`/uslugi#montaj`}>
                            <a>
                                <span>{t("Монтаж натяжных потолков")}</span>
                            </a>
                        </Link>
                        <Link href={`/uslugi#delivery`}>
                            <a>
                                <span>{t("Доставка товаров")}</span>
                            </a>
                        </Link>
                        <Link href={`/uslugi#movers`}>
                            <a>
                                <span>{t("Услуги грузчиков")}</span>
                            </a>
                        </Link>
                        <Link href={`/uslugi#garbage`}>
                            <a>
                                <span>{t("Вывоз строительного мусора")}</span>
                            </a>
                        </Link>
                        <Link href={`/uslugi#paint`}>
                            <a>
                                <span>
                                    {t("Колеровка красок и декоративных")} <br /> {t("штукатурок")}
                                </span>
                            </a>
                        </Link>
                        <Link href={`/uslugi#manipulyator`}>
                            <a>
                                <span>{t("Услуги манипулятора")}</span>
                            </a>
                        </Link>
                        <Link href={`/uslugi#individual_manager`}>
                            <a>
                                <span>{t("Индивидуальный менеджер")}</span>
                            </a>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withTranslation("services")(ServicePanel);
